import { createContext, useContext, useState } from 'react'
import { BaseFileInput, BaseGridLayout, BaseScatola, ICONE, MIME_TYPES, GRUPPI_MIME_TYPES, BaseDownloadLink, BaseIconButtons, jsFileDownload } from '@lucan/base-ui'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { LINK_FORM_CARICA_FILE } from 'configuration/link'
import Testo from 'components/ui/Testo'
import ConfigManager from 'components/config/ConfigManager'
import Titoletto from 'components/ui/Titoletto'

const FormCaricaFileContext = createContext()

const CFG = LINK_FORM_CARICA_FILE

export default function FormCaricaFile(props) {
  const {
    fileCaricato: fileCaricato_Prop, 
    ...restProps
  } = props

  const { val } = useContext(FormCaricaFileContext)

  const [fileCaricato, setFileCaricato] = useState(fileCaricato_Prop)

  if (fileCaricato) {
    const { name, type } = fileCaricato
    return (
      <BaseGridLayout spacing={0}>
        <BaseDownloadLink
          nomeFile={name}
          mimetype={type}
          onClick={() => jsFileDownload(fileCaricato, name)}
          toastProps={{ messaggio: val(CFG.FILE_SCARICATO) }}
          propsBottoneScarica={{ contenutoTooltip: val(CFG.BOTTONE_SCARICA) }}
        />
        <BaseIconButtons.Elimina
          contenutoTooltip={val(CFG.BOTTONE_ELIMINA)}
          onClick={() => setFileCaricato(null)}
          disabled={restProps.readOnly}
        />
      </BaseGridLayout>
    )
  }

  return (
    <BaseFileInput
      required
      tipiFileAccettati={[GRUPPI_MIME_TYPES.IMMAGINI, MIME_TYPES.PDF]}
      messaggioFormatiValidi={val(CFG.FORMATI_VALIDI)}
      messaggioDimensioneMax={val(CFG.DIMENSIONE_MAX)}
      messaggioFileScaricato={val(CFG.FILE_SCARICATO)}
      testoBottoneCarica={val(CFG.BOTTONE_CARICA)}
      testoBottoneScarica={val(CFG.BOTTONE_SCARICA)}
      testoBottoneElimina={val(CFG.BOTTONE_ELIMINA)}
      {...restProps}
    />
  )
}



export function FormCaricaFileProvider(props) {
  const { children } = props

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_LINK_FORM_CARICA_FILE]}
      render={({ val, txt }) =>
        <FormCaricaFileContext.Provider value={{ val, txt }}>
          {children}
        </FormCaricaFileContext.Provider>
      }
    />
  )
}



export function RiassuntoFileCaricato(props) {
  const { nome, file } = props

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_LINK_FORM_CARICA_FILE]}
      render={({ txt }) =>
        <BaseScatola outlined>
          <Titoletto variant='h6'>{nome}</Titoletto>

          <BaseGridLayout alignCenter spacing={1}>
            <ICONE.ALLEGATO />
            {file ? (
              <>
                <Testo>{file.name}</Testo>
                <Testo grassetto sx={{ color: 'success.main' }}>{txt(CFG.CARICAMENTO_EFFETTUATO)}</Testo>
              </>
            ) : (
              <Testo grassetto sx={{ color: 'error.main' }}>{txt(CFG.DA_CARICARE)}</Testo>
            )}
          </BaseGridLayout>
        </BaseScatola>
      }
    />
  )
}